import type { JSX } from 'react';
import { BariPreNurseSpecialistMedScreeningReportAanvullendeOnderzoeken } from './BariPreNurseSpecialistMedScreeningReportAanvullendeOnderzoeken';
import { BariPreNurseSpecialistMedScreeningReportAnamnese } from './BariPreNurseSpecialistMedScreeningReportAnamnese';
import { BariPreNurseSpecialistMedScreeningReportComorbiditeiten } from './BariPreNurseSpecialistMedScreeningReportComorbiditeiten';
import { BariPreNurseSpecialistMedScreeningReportConclusie } from './BariPreNurseSpecialistMedScreeningReportConclusie';
import { BariPreNurseSpecialistMedScreeningReportFamiliaireBelasting } from './BariPreNurseSpecialistMedScreeningReportFamiliaireBelasting';
import { BariPreNurseSpecialistMedScreeningReportLichamelijkOnderzoek } from './BariPreNurseSpecialistMedScreeningReportLichamelijkOnderzoek';
import { BariPreNurseSpecialistMedScreeningReportMedicatie } from './BariPreNurseSpecialistMedScreeningReportMedicatie';
import { BariPreNurseSpecialistMedScreeningReportSpecieleAnamnese } from './BariPreNurseSpecialistMedScreeningReportSpecieleAnamnese';

export function BariPreNurseSpecialistMedScreeningReportEdit(): JSX.Element {
    return (
        <>
            <BariPreNurseSpecialistMedScreeningReportAnamnese />
            <BariPreNurseSpecialistMedScreeningReportSpecieleAnamnese />
            <BariPreNurseSpecialistMedScreeningReportMedicatie />
            <BariPreNurseSpecialistMedScreeningReportFamiliaireBelasting />
            <BariPreNurseSpecialistMedScreeningReportComorbiditeiten />
            <BariPreNurseSpecialistMedScreeningReportLichamelijkOnderzoek />
            <BariPreNurseSpecialistMedScreeningReportAanvullendeOnderzoeken />
            <BariPreNurseSpecialistMedScreeningReportConclusie />
        </>
    );
}
